export default "<div style=\"border:1px solid black; background-color: white; padding: 1em; font-size: 2em;\" class=\"draghandle\">\n    ?\n</div>";